import { NavigationSection } from './nav-model';

export const NAV_SECTIONS: NavigationSection[] = [
  {
    // title: 'Main Menu',
    items: [
      {
        label: 'Dashboard',
        icon: 'fa-solid fa-home',
        route: '/dashboard',
      },
      {
        label: 'Display',
        icon: 'fa-solid fa-display',
        route: '/display',
        module: 'Display',
      },
      {
        label: 'Media',
        icon: 'fa-solid fa-images',
        route: '/media',
        module: 'Media',
      },
      {
        label: 'Layouts',
        icon: 'fa-solid fa-border-all',
        route: '/layouts',
        module: 'Layout',
      },
      {
        label: 'Schedule',
        icon: 'fa-solid fa-calendar-days',
        route: '/schedule',
        module: 'Schedule',
      },
      {
        label: 'Users',
        icon: 'fa-solid fa-user-gear',
        route: '/users',
        module: 'User',
      },
      {
        label: 'Slots',
        icon: 'fa-solid fa-clock',
        route: '/slots',
        module: 'Slots',
        roles: ['Admin', 'tenant_admin'],
      },
      {
        label: 'Vehicles',
        icon: 'fa-solid fa-bus',
        route: '/vehicles',
        module: 'Vehicle',
      },
      {
        label: 'Zones',
        icon: 'fa-solid fa-location-crosshairs',
        route: '/geofencing',
        module: 'Zone',
      },
      {
        label: 'Campaign',
        icon: 'fa-solid fa-bullhorn',
        route: '/campaign',
        module: 'Campaign',
      },
      {
        label: 'Slot Requests',
        icon: 'fa-solid fa-clipboard-check',
        route: '/slot-requests',
        roles: ['Agency'],
      },
      {
        label: 'Bidding Results',
        icon: 'fa-solid fa-gavel',
        route: '/bidding',
        roles: ['Agency'],
      },
      {
        label: 'My Bids',
        icon: 'fa-solid fa-gavel',
        route: '/bidding',
        roles: ['Advertiser'],
      },
      {
        label: 'Bidding',
        icon: 'fa-solid fa-gavel',
        route: '/bidding',
        roles: ['Admin', 'tenant_admin'],
      },
      {
        label: 'Billing',
        icon: 'fa-solid fa-file-invoice-dollar',
        route: '/billing',
        module: 'Billing',
      },
      {
        label: 'Advertiser',
        icon: 'fa-solid fa-rectangle-ad',
        route: '/advertiser',
        module: 'Advertiser',
      },
      {
        label: 'Reports',
        icon: 'fa-solid fa-chart-line',
        route: '/reports',
        module: 'Report',
      },
      {
        label: 'Driver',
        icon: 'fa-solid fa-id-card',
        route: '/driver',
        module: 'Driver',
      },
    ],
  },
];
